import { render, staticRenderFns } from "./PlansTable.vue?vue&type=template&id=ac630e44&scoped=true&"
import script from "./PlansTable.vue?vue&type=script&lang=js&"
export * from "./PlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac630e44",
  null
  
)

export default component.exports